<div *ngIf="listingCategory==ListingCategory.RESIDENTIAL" class="balloon is-flex">
  <img class="lazypreload lazyload" imageQualityPercentage=100
  appImgIxImage url="{{'/assets/BalloonLarge.svg' | staticp }}" alt="{{ 'logo.residential' | translate }}">
</div>
<div *ngIf="listingCategory===ListingCategory.COMMERCIAL" class="logo is-flex">
  <img class="lazypreload lazyload" imageQualityPercentage=100
  appImgIxImage url="{{'/assets/REMAX_Logo/REMAX_Commercial.svg' | staticp }}" height="60" width="150" alt="{{ 'logo.commercial' | translate }}">
</div>
<div *ngIf="listingCategory===ListingCategory.LUXURY" class="logo is-flex">
  <img class="lazypreload lazyload" imageQualityPercentage=100
  appImgIxImage url="{{'/assets/REMAX_Logo/REMAX_Collection.svg' | staticp }}" alt="{{ 'logo.luxury' | translate }}">
</div>
